<ion-header>
	<ion-toolbar>
		<ion-title *ngIf="title" [style.font-size]="titleSize">{{ title }}</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="closeModal()" aria-label="Fechar">
				<ion-icon name="close" slot="icon-only"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="viewer-content">
	<div
		class="zoom-area"
		(touchstart)="onTouchStart($event)"
		(touchmove)="onTouchMove($event)"
		(touchend)="onTouchEnd($event)"
		(dblclick)="onDoubleClick()"
	>
		<img #img [src]="src" [alt]="alt || title || ''" draggable="false" (error)="onImgError()" />
	</div>
</ion-content>

<ion-footer *ngIf="text || actionLabel" class="viewer-footer">
	<!-- Ancorado ACIMA da descrição, dentro do rodapé. Continua parecendo solto
	     sobre a foto porque o ion-content é fullscreen e a imagem passa por baixo
	     do rodapé transparente — mas a posição agora é relativa ao texto, então
	     descrição longa empurra o botão para cima em vez de ser encoberta. -->
	<div
		class="viewer-action-float"
		[class.viewer-action-float--still]="actionDisabled"
		*ngIf="actionLabel"
	>
		<button
			#actionBtn
			type="button"
			class="viewer-action"
			[class.viewer-action--light]="useLightAction"
			data-cy="viewerSelectItem"
			[disabled]="actionDisabled"
			[attr.aria-disabled]="actionDisabled"
			(click)="selectItem()"
		>
			<span class="viewer-action__label">{{ actionText | translate }}</span>
			<span class="viewer-action__puck" *ngIf="!actionDisabled" aria-hidden="true">
				<ion-icon class="viewer-action__icon" name="arrow-forward"></ion-icon>
			</span>
		</button>
	</div>
	<ion-text *ngIf="text" tabindex="0">{{ text }}</ion-text>
</ion-footer>
